import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "formulario-modelo"
}
const _hoisted_2 = { class: "selector-cards" }

import { ref } from 'vue'
import { useRoute } from 'vue-router'
import ProcesoAdminView   from '@/views/ProcesoAutoevaluacionAdminView.vue'
import ProcesoUsuarioView from '@/views/ProcesoAutoevaluacionUsuarioView.vue'
import useAutenticar from '@/store/IngresoAutenticar'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProcesoAutoevaluacionView',
  setup(__props) {

/**
 * Administración de ejecuciones de modelo.
 *
 * Es la pantalla donde entra el ÁREA evaluada: `ambito` e `id_programa` son
 * columnas de la ejecución y de ninguna otra entidad.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/procesos-autoevaluacion` (ProcesoAutoevaluacion) — permiso `procesos.ver`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const store = useAutenticar()

const modoInicial = route.query.modo === 'admin' ? 'admin'
  : route.query.modo === 'usuario' ? 'usuario'
  : null
const modo = ref<'admin' | 'usuario' | null>(modoInicial)

return (_ctx: any,_cache: any) => {
  return (!modo.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("h1", null, "Proceso de Autoevaluación", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "subtitulo" }, "Selecciona el modo con el que deseas ingresar", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "divider" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          (_unref(store).tienePermiso('procesos.crear') || _unref(store).tienePermiso('procesos.asignar'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "modo-card",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (modo.value = 'admin'))
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("span", { class: "modo-nombre" }, "Administrador", -1),
                _createElementVNode("span", { class: "modo-desc" }, "Crear y gestionar procesos de autoevaluación", -1)
              ])))
            : _createCommentVNode("", true),
          (_unref(store).tienePermiso('calificacion.calificar') || _unref(store).tienePermiso('calificacion.ver'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "modo-card",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (modo.value = 'usuario'))
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("span", { class: "modo-nombre" }, "Usuario", -1),
                _createElementVNode("span", { class: "modo-desc" }, "Ver y completar las evaluaciones asignadas", -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ]))
    : (modo.value === 'admin')
      ? (_openBlock(), _createBlock(ProcesoAdminView, {
          key: 1,
          onCambiarModo: _cache[2] || (_cache[2] = ($event: any) => (modo.value = null))
        }))
      : (modo.value === 'usuario')
        ? (_openBlock(), _createBlock(ProcesoUsuarioView, {
            key: 2,
            onCambiarModo: _cache[3] || (_cache[3] = ($event: any) => (modo.value = null))
          }))
        : _createCommentVNode("", true)
}
}

})